import React from 'react';

const Customersupport = () => {
  return (
    <div className='container'>
        <div className='text-xl'><strong>Email</strong></div>
        <div className='mt-4'>
        For non-urgent matters, we recommend reaching out via email to campusify2@gmail.com.

To enhance the efficiency of your email and expedite assistance based on the nature of your issue, please consider the following guidelines:

Technical Issues:

Desktop Version: Specify your operating system and browser.
App Issues: Provide details on your operating system and app version.
Include screenshots illustrating the problem, if possible.
Payment-related Concerns for Premium Services:

Describe the payment issue, specifying the purchased package, payment method, amount, payment date, and depositor's name.
Attach a copy of the payment receipt or debit alert for prompt assistance.
Scam Report:

If you encounter a scam or suspect deceptive behavior, inform us via email.
Include a link to the user's profile involved in the scam and provide a detailed description.
Attach screenshots of your conversations and any relevant materials supporting your case.
Phone Number

For urgent matters or immediate assistance, you can contact us via phone at the following numbers:

+23481649100957
+2347042380116
Your cooperation in providing detailed information will enable us to address your concerns more effectively. Thank you for choosing Campusify.
        </div>
    </div>
  )
}

export default Customersupport;